/* PurePetZone — toglie la firma "Powered by Track123" dalla pagina di
   tracciamento.

   PERCHE' SERVE UN FILE APPOSTA, invece di due righe di CSS.
   La firma non si puo' nascondere con un foglio di stile: l'app le scrive lo
   stile DIRETTAMENTE SULL'ELEMENTO, e con !important:

     style="... display: block !important; visibility: visible !important; ..."

   Uno stile scritto sull'elemento con !important vince su qualunque regola di
   qualunque foglio, per come e' fatto il CSS. Non e' un caso: hanno messo
   anche visibility, cioe' si sono difesi apposta. L'unico modo e' togliere
   l'elemento dopo che l'hanno creato.

   PERCHE' NON BASTA FARLO UNA VOLTA SOLA.
   La pagina e' un'applicazione che si ridisegna da sola: cambi linguetta,
   cerchi un ordine, e la firma torna. Percio' si resta in ascolto delle
   modifiche e si toglie ogni volta che ricompare.

   Il file viene caricato SOLO su /apps/track123 (vedi layout/theme.liquid):
   sulle altre pagine non esiste e non costa niente. */

(function () {
  'use strict';

  var ID = 'track123-powered-by';

  function togli() {
    var e = document.getElementById(ID);
    if (!e) return false;
    // Si toglie dal documento invece di nasconderlo: se restasse, i lettori di
    // schermo continuerebbero a leggerlo e resterebbe lo spazio sotto al
    // pulsante.
    e.remove();
    return true;
  }

  togli();

  // Resta in ascolto: l'applicazione ricostruisce il suo pezzo di pagina a
  // ogni ricerca, e la firma torna insieme al resto.
  var radice = document.getElementById('track123-app') || document.body;
  if (!radice || typeof MutationObserver !== 'function') return;

  var osservatore = new MutationObserver(function () { togli(); });
  osservatore.observe(radice, { childList: true, subtree: true });

  // Rete di sicurezza per i primi secondi: se l'applicazione parte piu' tardi
  // del previsto, il contenitore osservato potrebbe non esistere ancora.
  var tentativi = 0;
  var timer = setInterval(function () {
    tentativi++;
    if (togli() || tentativi > 40) clearInterval(timer);
  }, 250);
})();
